import React from 'react'

const Glass = ({ amount }) =>
  <svg
    width="149px"
    height="196px"
    viewBox="0 0 149 196"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <polygon
        id="path-1"
        points="74.1465433 195.800813 0 195.800813 0 0.796747967 74.1465433 0.796747967 148.293087 0.796747967 148.293087 195.800813"
      />
      <path
        d="M23,158.74013 L23,0.25102439 L77,0.25102439 L77,158.74013 L23,158.74013 Z M0.651532086,0.251104065 L28.2659332,0.251104065 L29.5933877,158.74021 L18.3020561,158.74021 L18.2502647,158.74021 C9.67838235,158.74021 8.19953743,154.246551 8.16925936,148.713933 L0.65392246,0.352291057 L0.651532086,0.302095935 L0.651532086,0.251104065 Z M99.7174091,0.251104065 L99.7174091,0.302095935 L99.7150187,0.352291057 L92.198885,148.713933 C92.1694037,154.246551 90.6905588,158.74021 82.1186765,158.74021 L82.066885,158.74021 L70.7755535,158.74021 L72.103008,0.251104065 L99.7174091,0.251104065 Z"
        id="path-3"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none">
      <g transform="translate(-113.000000, -224.000000)">
        <g id="Glass" transform="translate(113.000000, 224.000000)">
          <g id="glass">
            <path
              d="M136.666465,4.7804878 L136.605112,4.7804878 L10.3455401,4.7804878 L10.284984,4.7804878 C6.44046524,4.7804878 3.31305882,7.90772358 3.31305882,11.7520325 C3.31305882,13.533561 4.32578075,14.7302764 5.21978075,15.7867642 C6.2954492,17.0575772 7.3105615,18.2582764 7.3105615,20.9146341 L7.3105615,20.9743902 L7.31374866,21.0341463 L15.2792727,179.929593 C15.3143316,186.490016 20.6623957,191.817073 27.2311444,191.817073 L27.2924973,191.817073 L119.658155,191.817073 L119.718711,191.817073 C126.288257,191.817073 131.637118,186.490016 131.670583,179.929593 L139.637701,21.0341463 L139.640091,20.9743902 L139.640091,20.9146341 C139.640091,18.2582764 140.655203,17.0575772 141.730075,15.7867642 C142.625668,14.7302764 143.63839,13.533561 143.63839,11.7520325 C143.63839,7.90772358 140.510187,4.7804878 136.666465,4.7804878"
              id="Fill-1"
              fill="#D3E6EB"
              fillRule="nonzero"
            />
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g id="path-1" />
            <path
              d="M137.337204,0.796747967 L137.275851,0.796747967 L11.0170759,0.796747967 L10.955723,0.796747967 C4.91445027,0.796747967 -0.000159358289,5.71108943 -0.000159358289,11.7520325 C-0.000159358289,14.9932033 1.78385668,17.1013984 2.84996364,18.3602602 C3.75511872,19.4302927 3.99814011,19.717122 3.99814011,20.9146341 L3.99814011,21.0739837 L4.00610802,21.2341301 L11.9676481,180.045122 C12.0640599,188.748797 19.1754235,195.800813 27.9026802,195.800813 L27.9640332,195.800813 L120.328894,195.800813 L120.390247,195.800813 C129.117504,195.800813 136.228867,188.748797 136.325279,180.045122 L144.286819,21.2341301 L144.294787,21.0739837 L144.294787,20.9146341 C144.294787,19.717122 144.538605,19.4302927 145.442964,18.3602602 C146.509071,17.1013984 148.293087,14.9932033 148.293087,11.7520325 C148.293087,5.71108943 143.378477,0.796747967 137.337204,0.796747967 M137.337204,7.17073171 C139.867814,7.17073171 141.918755,9.22156098 141.918755,11.7520325 C141.918755,14.0841138 137.920456,15.1382114 137.920456,20.9146341 L129.951744,179.865854 C129.951744,185.145902 125.671381,189.426829 120.390247,189.426829 L120.328894,189.426829 L27.9640332,189.426829 L27.9026802,189.426829 C22.6215465,189.426829 18.3411829,185.145902 18.3411829,179.865854 L10.3724717,20.9146341 C10.3724717,15.1382114 6.37417219,14.0841138 6.37417219,11.7520325 C6.37417219,9.22156098 8.42511337,7.17073171 10.955723,7.17073171 L11.0170759,7.17073171 L137.275851,7.17073171 L137.337204,7.17073171"
              id="Fill-7"
              fill="#2A2A41"
              fillRule="nonzero"
              mask="url(#mask-2)"
            />
            <polygon
              id="Fill-10"
              style={{ opacity: 0.5 }}
              fill="#FFFFFF"
              fillRule="nonzero"
              mask="url(#mask-2)"
              points="79.3564439 177.74013 86.622385 177.74013 86.622385 19.2510244 79.3564439 19.2510244"
            />
            <path
              d="M92.4974471,74.1527756 L108.433276,74.1527756"
              id="Stroke-12"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M85.3255273,153.83538 L108.433276,153.83538"
              id="Stroke-14"
              stroke="#2A2A41"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M92.4974471,169.771933 L108.433276,169.771933"
              id="Stroke-16"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M23.7255807,147.192176 L25.0610032,173.82268 C25.0904845,179.355298 26.5693294,183.848956 35.1420086,183.848956 L35.1938,183.848956 L113.099287,183.848956 L113.150281,183.848956 C121.686308,183.848956 123.202602,179.355298 123.231287,173.82268 L125.190597,146.668712 L23.7255807,147.192176 Z"
              id="Fill-18"
              mask="url(#mask-2)"
            />
            <path
              d="M24.6515321,19.2511041 L24.6515321,19.3020959 L24.6539225,19.3522911 L32.1692594,167.713933 C32.1995374,173.246551 33.6783824,177.74021 42.2502647,177.74021 L42.3020561,177.74021 L53.5933877,177.74021 L52.2659332,19.2511041 L24.6515321,19.2511041 Z"
              id="Fill-20"
              style={{ opacity: 0.15 }}
              fill="#1D1D1B"
              fillRule="nonzero"
              mask="url(#mask-2)"
            />
            <path
              d="M123.717409,19.2511041 L123.717409,19.3020959 L123.715019,19.3522911 L116.198885,167.713933 C116.169404,173.246551 114.690559,177.74021 106.118676,177.74021 L106.066885,177.74021 L94.7755535,177.74021 L96.103008,19.2511041 L123.717409,19.2511041 Z"
              id="Fill-22"
              style={{ opacity: 0.5 }}
              fill="#FFFFFF"
              fillRule="nonzero"
              mask="url(#mask-2)"
            />
            <path
              d="M93.2942385,58.2163024 L108.433276,58.2163024"
              id="Stroke-29"
              stroke="#2A2A41"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M93.2942385,90.0893285 L108.433276,90.0893285"
              id="Stroke-31"
              stroke="#2A2A41"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M92.4974471,106.025802 L108.433276,106.025802"
              id="Stroke-33"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M93.2942385,121.962354 L108.433276,121.962354"
              id="Stroke-35"
              stroke="#2A2A41"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M92.4974471,137.898828 L108.433276,137.898828"
              id="Stroke-37"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M92.4974471,42.2797496 L108.433276,42.2797496"
              id="Stroke-39"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M93.2942385,26.3432764 L108.433276,26.3432764"
              id="Stroke-41"
              stroke="#2A2A41"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M92.4974471,74.1527756 L108.433276,74.1527756"
              id="Stroke-43"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M93.2942385,153.83538 L108.433276,153.83538"
              id="Stroke-45"
              stroke="#2A2A41"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <path
              d="M92.4974471,169.771933 L108.433276,169.771933"
              id="Stroke-47"
              stroke="#2A2A41"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
            <g id="Fill-7-Clipped" mask="url(#mask-2)">
              <g transform="translate(0.000000, 0.597561)" />
            </g>
          </g>
          <g id="liquid" transform="translate(24.000000, 19.000000)">
            <mask id="mask-4" fill="white">
              <use xlinkHref="#path-3" />
            </mask>
            <use
              id="Combined-Shape"
              fillOpacity="0"
              fill="#none"
              fillRule="nonzero"
              xlinkHref="#path-3"
            />
            <rect
              id="Rectangle"
              fill="#FFD474"
              style={{ opacity: 0.8 }}
              mask="url(#mask-4)"
              x="-20"
              y={160 - amount * 1.5}
              width="120"
              height={amount * 1.5}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>

export default Glass



// WEBPACK FOOTER //
// ./src/containers/Amount/Glass.js